import { msg } from '@gonfalon/messages/msg';

import { ApprovalsReviewKind } from './constants';

export const getApprovalErrorNotificationMessage = (reviewKind: ApprovalsReviewKind) => {
  if (reviewKind === ApprovalsReviewKind.COMMENT) {
    return msg('approvals.notification.commentFailed');
  }

  return msg('approvals.notification.reviewFailed', { reviewKind });
};
